import React from 'react';
import { motion } from 'framer-motion';

// Mirrors the Elementor entrance animations used on the live site
type Anim = 'slideInLeft' | 'slideInUp' | 'fadeInUp';
const VARIANTS: Record<Anim, {
  hidden: any;
  show: any;
}> = {
  slideInLeft: {
    hidden: {
      opacity: 0,
      x: -80
    },
    show: {
      opacity: 1,
      x: 0
    }
  },
  slideInUp: {
    hidden: {
      opacity: 0,
      y: 80
    },
    show: {
      opacity: 1,
      y: 0
    }
  },
  fadeInUp: {
    hidden: {
      opacity: 0,
      y: 40
    },
    show: {
      opacity: 1,
      y: 0
    }
  }
};
export function Reveal({
  anim = 'slideInUp',
  delay = 0,
  className = '',
  children
}: {
  anim?: Anim;
  delay?: number;
  className?: string;
  children: React.ReactNode;
}) {
  return <motion.div className={className} initial="hidden" whileInView="show" viewport={{
    once: true,
    amount: 0.2
  }} variants={VARIANTS[anim]} transition={{
    duration: 0.8,
    ease: 'easeOut',
    delay
  }} data-id="element-210" data-mp="2spjs8ya359ly">
      {children}
    </motion.div>;
}